<template>
  <div class="dropdown-menu" :style="positionClass">
    <ul>
      <li
        v-for="(item, index) in menuItems"
        :key="index"
        @click.stop="
          onMenuClick(
            (() => {
              return item.label ? item.label : item;
            })()
          )
        "
      >
        <!-- <span v-if="item.icon"><font-awesome-icon :icon="item.icon"/></span> -->
        <span v-if="item.label">{{ item.label }}</span>
        <span v-else>{{ item }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    parentLeft: {
      type: Number,
      default: null
    }
  },
  computed: {
    positionClass() {
      if (this.parentLeft) {
        return {
          postion: 'absolute',
          left: `${this.parentLeft}px`
        };
      }
      return '';
    }
  },
  methods: {
    onMenuClick(label) {
      this.$emit('optionClicked', { menuOption: label });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
.dropdown-menu {
  position: absolute;
  background-color: $white;
  color: $black;
  opacity: 1;
  width: default;
  z-index: 50;

  &.dropdown-menu-right {
    top: 100%;
    border: 1px solid $light-grey-2;
    ul li:first-child {
      border-top: 0;
    }
    ul li:hover {
      background-color: $light-grey-2;
    }
  }

  > ul {
    list-style: none;
    margin: 0;
    padding: 0;

    > li {
      padding: 15px 15px;

      border-top: 1px solid $row-border;
      &:hover {
        cursor: pointer;
      }

      > span {
        margin-right: 15px;
      }
    }
  }
}
</style>
